import { Controller } from "@hotwired/stimulus"

export default class WorkerAutocompleteBaseController extends Controller {
  connect() {
    this.timeout = null
    this.abortController = null
  }

  disconnect() {
    clearTimeout(this.timeout)
    this.abortController?.abort()
  }

  onAutocompleteInput({ minQueryLength = 2, delay = 200 } = {}) {
    clearTimeout(this.timeout)

    const query = this.inputTarget.value.trim()
    if (query.length < minQueryLength) {
      this.renderWorkerResults([])
      return
    }

    this.timeout = setTimeout(() => {
      this.performSearch(query)
    }, delay)
  }

  async performSearch(query) {
    try {
      this.abortController?.abort()
      this.abortController = new AbortController()

      const url = new URL(this.urlValue, window.location.origin)
      url.searchParams.set("q", query)

      const response = await fetch(url.toString(), {
        headers: { Accept: "application/json" },
        signal: this.abortController.signal
      })

      if (!response.ok) {
        this.renderWorkerResults([])
        return
      }

      const data = await response.json()
      this.renderWorkerResults(Array.isArray(data.workers) ? data.workers : [])
    } catch (error) {
      if (error?.name === "AbortError") return
      this.renderWorkerResults([])
    }
  }

  renderWorkerResults(_workers) {}
}
